module.exports = __webpack_public_path__ + "v294910/img/doctor.cb8a79dc.png";